import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Stepper} from "@interstate/components/Stepper";

export interface CreateOrganizationStepperProps {
  activeStep: 0 | 1;
  reviewPlanCompleted?: boolean;
  reviewPlanError?: boolean;
  resultsCompleted?: boolean;
  resultsError?: boolean;
}

export const OrganizationStepper: FC<CreateOrganizationStepperProps> = ({
  activeStep,
  reviewPlanCompleted,
  reviewPlanError,
  resultsCompleted,
  resultsError
}) => {
  const {t} = useTranslation();
  return (
    <Stepper
      data-testid="organization-stepper"
      activeStep={activeStep}
      labels={[
        {
          label: reviewPlanError
            ? t("create-organization.stepper.step-labels.error")
            : t("create-organization.stepper.step-labels.review-plan"),
          ...(reviewPlanCompleted && {completed: true}),
          ...(reviewPlanError && {error: true}),
          slotProps: {
            button: {dataAttr: {"data-testid": "review-plan-stepper-button"}}
          }
        },
        {
          label: resultsError
            ? t("create-organization.stepper.step-labels.error")
            : t("create-organization.stepper.step-labels.results"),
          ...(resultsCompleted && {completed: true}),
          ...(resultsError && {error: true}),
          slotProps: {
            button: {dataAttr: {"data-testid": "results-stepper-button"}}
          }
        }
      ]}
    />
  );
};
